import Base from "./_BaseComponent";
import $ from "jquery";

class VideoHeader extends Base.Component {
	private videoEl: JQuery<HTMLVideoElement>;
	private playPauseBtn: JQuery<HTMLButtonElement>;
	private progressEl: JQuery<HTMLInputElement>;
	private audioMuteBtn: JQuery<HTMLButtonElement>;
	private videoLength: number;
	private seekEventActive: boolean;

	public onMount(): void {
		this.videoEl = this.element.find("[data-video]") as JQuery<
			HTMLVideoElement
		>;
		this.playPauseBtn = this.element.find("[data-play-pause]") as JQuery<
			HTMLButtonElement
		>;
		this.audioMuteBtn = this.element.find("[data-audio]") as JQuery<
			HTMLButtonElement
		>;
		this.progressEl = this.element.find("[data-range]") as JQuery<
			HTMLInputElement
		>;

		if (!this.videoEl) {
			console.warn(`Couldn't find [data-video] element to attach to.`);
			return;
		}

		this.progressEl.on("touchstart mousedown", this.startSeek.bind(this));
		this.progressEl.on("touchend mouseup", this.stopSeek.bind(this));
		$(window).on("blur", this.stopSeek.bind(this));

		this.videoEl.on("loadedmetadeta", this.setupVideoMeta.bind(this));
		this.videoEl.on("durationchange", this.setupVideoMeta.bind(this));
		this.setupVideoMeta();

		this.videoEl.on("timeupdate", this.setProgress.bind(this));

		this.playPauseBtn.on("click", this.togglePlay.bind(this));
		this.videoEl.on("click", this.togglePlay.bind(this));
		this.audioMuteBtn.on("click", this.toggleMute.bind(this));
		this.element.addClass("playing muted");
	}

	private startSeek(): void {
		this.seekEventActive = true;
	}

	private stopSeek(): void {
		if (!this.seekEventActive) return;

		const newTime = (((this.progressEl.val() as any) / 100) *
			this.videoLength) as number;
		console.log(newTime);
		this.videoEl[0].currentTime = newTime;
		this.seekEventActive = false;
	}

	private setupVideoMeta(): void {
		// If video isn't ready, come back later...
		if (!this.videoEl[0].duration) return;

		this.videoLength = this.videoEl[0].duration;
	}

	private setProgress(): void {
		if (this.seekEventActive) return;

		const progress = (this.videoEl[0].currentTime / this.videoLength) * 100;
		this.progressEl.val(progress);
	}

	private togglePlay(e: Event): void {
		e.preventDefault();

		if (this.videoEl[0].paused) this.videoEl[0].play();
		else this.videoEl[0].pause();

		this.rerenderStatus();
	}

	private toggleMute(e: Event): void {
		e.preventDefault();

		this.videoEl[0].muted = !this.videoEl[0].muted;
		this.rerenderStatus();
	}

	private rerenderStatus(): void {
		if (this.videoEl[0].paused) {
			this.element.addClass("paused");
			this.element.removeClass("playing");
		} else {
			this.element.addClass("playing");
			this.element.removeClass("paused");
		}

		if (this.videoEl[0].muted) this.element.addClass("muted");
		else this.element.removeClass("muted");
	}
}

export default Base.Init("[data-component-video-header]", VideoHeader);
